import { jsx as _jsx } from "react/jsx-runtime";
import { IconContext } from "@phosphor-icons/react";
import { classes } from "./classes.js";
/**
 * Phosphor, in the duotone weight throughout (Broadsheet readme, "Icons").
 *
 * `weight` is not a prop. It is set here and nowhere else, so the wrong weight is
 * unavailable rather than discouraged. Size comes from `--icon-*`, resolved through a
 * class on the wrapper: the glyph is drawn at `1em`, so one token controls it.
 */
export const ICON_SIZES = ["xs", "sm", "md", "lg", "xl", "2xl", "3xl", "4xl"];
export const ICON_TONES = [
    "inherit",
    "accent",
    "muted",
    "positive",
    "caution",
    "critical",
];
export function Icon({ glyph: Glyph, size = "md", tone = "inherit", label }) {
    const decorative = label === undefined;
    return (_jsx("span", { className: classes("wt-icon", `wt-icon-${size}`, `wt-tone-${tone}`), children: _jsx(Glyph, { weight: "duotone", size: "1em", "aria-hidden": decorative, "aria-label": label, role: decorative ? undefined : "img", focusable: "false" }) }));
}
/**
 * Locks the duotone weight for any Phosphor glyph rendered inside, including ones a
 * future unit renders directly. Mount it once, at the application shell.
 */
export function IconProvider({ children }) {
    return _jsx(IconContext.Provider, { value: { weight: "duotone" }, children: children });
}
//# sourceMappingURL=icon.js.map